import { DETECT_SUBS } from '../../lib/profiles';

export const SUBS = Object.keys(DETECT_SUBS);
// detection sub-area chip (water, gas, cable …); clickable when onClick is given
export function SubChip({ s, t, active, onClick, testid }) {
  const C = onClick ? 'button' : 'span';
  return <C className={`pm-chip pm-sub ${active ? 'active' : ''}`} data-testid={testid} onClick={onClick} type={onClick ? 'button' : undefined}>{DETECT_SUBS[s]?.icon} {t[`dsub_${s}`] || s}</C>;
}
// multi-select of sub-areas for a project with the detection branch
export function SubPick({ t, value = [], onChange, prefix }) {
  const tog = (s) => onChange(value.includes(s) ? value.filter((x) => x !== s) : [...value, s]);
  return <div className="pm-branch-chips pm-subs" data-testid={`${prefix}-subs`}>{SUBS.map((s) => <SubChip key={s} s={s} t={t} active={value.includes(s)} onClick={() => tog(s)} testid={`${prefix}-sub-${s}`} />)}</div>;
}
